/**
 * @description: 门票营业明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="tsr-mym-report">
        <div class="mym-list" v-show="mymShowList">
            <el-form :inline="true" size="small" :model="mym_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="mym_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="mym_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="mym_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="mym_list_form.shop_id" filterable placeholder="请选择门店" @change="mymShopChange">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管家">
                    <el-select v-model="mym_list_form.shopping_guide" filterable clearable placeholder="请选择管家">
                        <el-option v-for="item in guide_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-select v-model="mym_list_form.admin_id" filterable clearable placeholder="请选择操作人">
                        <el-option v-for="item in guide_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-input v-model="mym_tpl_txt" class="el-ellipsis" clearable placeholder="请选择类型" @focus="mymTplSelect" @clear="mymTplDel"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input placeholder="请输入门票名称" v-model="mym_list_form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getMymList(1)">查询</el-button>
                    <el-button @click="mymExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="mym_list">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="create_time" label="操作时间"></el-table-column>
                <el-table-column prop="order_id" label="订单号"></el-table-column>
                <el-table-column prop="real_pay_total" label="实收金额"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="shopping_guide_name" label="管家"></el-table-column>
                <el-table-column prop="info_type_name" label="类型"></el-table-column>
                <el-table-column prop="relation_name" label="名称"></el-table-column>
                <el-table-column prop="quantity" label="数量"></el-table-column>
                <el-table-column prop="discount_price" label="单价"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="getMymDet(scope.row.order_id)">详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">实收总额:</label>
                    <div class="list-total">{{mym_actual_pay_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="mym_list_page"
                    :total="mym_list_total"
                    @current-change="getMymList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="mym_list_export">
                <h2>请选择导出报表需要的显示的字段</h2>
                <el-checkbox :indeterminate="mym_export_sign" v-model="mym_export_all" @change="mymExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="mym_export_ids" @change="mymExportChange">
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="create_time">操作时间</el-checkbox>
                    <el-checkbox label="order_id">订单号</el-checkbox>
                    <el-checkbox label="real_pay_total">实收金额</el-checkbox>
                    <el-checkbox label="admin_name">操作人</el-checkbox>
                    <el-checkbox label="shopping_guide_name">管家</el-checkbox>
                    <el-checkbox label="info_type_name">类型</el-checkbox>
                    <el-checkbox label="relation_name">名称</el-checkbox>
                    <el-checkbox label="quantity">数量</el-checkbox>
                    <el-checkbox label="discount_price">单价</el-checkbox>
                </el-checkbox-group>
                <h2>请选择导出报表的文件格式</h2>
                <el-radio v-model="mym_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="mym_export_type" label="2">pdf文件</el-radio>
            </div>
            <!-- 类型弹窗 -->
            <div class="export-wrap" ref="mym_tpl_alert">
                <el-checkbox :indeterminate="mym_tpl_sign" v-model="mym_tpl_all" @change="mymTplAll">全选</el-checkbox>
                <el-checkbox-group v-model="mym_tpl_ids" @change="mymTplChange">
                    <el-checkbox v-for="item in order_type_list" :key="item.value" :label="item.value">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <div class="mym-order" v-show="!mymShowList">
            <h2>订单详情</h2>
            <el-row>
                <el-col :span="12">
                    <el-form>
                        <el-form-item label="订单编号：">{{mym_order.order_id}}</el-form-item>
                        <el-form-item label="下单时间：">{{mym_order.create_time}}</el-form-item>
                        <el-form-item label="操作人：">{{mym_order.admin_name}}</el-form-item>
                        <el-form-item label="管家：">{{mym_order.shopping_guide_name}}</el-form-item>
                        <el-form-item label="会员卡：">{{mym_order.vip_card}}</el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form>
                        <el-form-item label="售价：">{{mym_order.discount_price}}</el-form-item>
                        <el-form-item label="实收金额：">{{mym_order.actual_pay}}</el-form-item>
                        <el-form-item label="支付方式：">{{mym_order.pay_platform_show}}</el-form-item>
                        <el-form-item label="支付人：">{{mym_order.ahead_user_name}}</el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-table
                :data="mym_order.order_infos"
                row-key="id"
                default-expand-all
                :tree-props="{children: 'infos', hasChildren: 'hasChildren'}">
                <el-table-column prop="relation_name" label="门票名称"></el-table-column>
                <el-table-column prop="quantity" label="数量"></el-table-column>
                <el-table-column prop="discount_price" label="售价"></el-table-column>
            </el-table>
            <el-row>
                <el-button class="jh-width130" @click="mymShowList=true">返回</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                guide_list: [],
                order_type_list: [],
                mymShowList: true,
                mym_list_form: {
                    start_time: moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm'),
                    end_time: moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm'),
                    shop_id: '',
                    shopping_guide: '',
                    admin_id: '',
                    name: ''
				},
                mym_tpl_txt: '',
				mym_tpl_sign: false,
				mym_tpl_all: false,
                mym_tpl_ids: [],
                mym_actual_pay_total: '',
				mym_list: [],
				mym_list_page: 1,
                mym_list_total: 0,
                mym_export_sign: false,
				mym_export_all: false,
                mym_export_ids: [],
                mym_export_list: ['shop_name', 'create_time', 'order_id', 'real_pay_total', 'admin_name', 'shopping_guide_name', 'info_type_name', 'relation_name', 'quantity', 'discount_price'],
                mym_export_type: '1',
                mym_order: {},
            }
        },
        watch: {
            '$route': {
				handler: function(val, oldVal) {
					if(val.params.start_time) {
                        this.mym_list_form = {
                            start_time: val.params.start_time,
                            end_time: val.params.end_time,
                            shop_id: val.params.shop_id,
                            shopping_guide: val.params.shopping_guide,
                            admin_id: '',
                            name: ''
				        }
                        this.mymTplInit(val.params.deduct_group_price)
                        this.getMymList(1)
					}
				},
				deep: true
			},
        },
        created: function() {
            this.getOrderType()
        },
        mounted: function() {
            this.initDate()
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                new Promise(resolve => {
                    this.getGuide(this.shop_list[0].id, resolve)
                }).then(res => {
                    if(this.$route.params.start_time) {
                        // 第一次打开
                        this.mym_list_form = {
                            start_time: this.$route.params.start_time,
                            end_time: this.$route.params.end_time,
                            shop_id: this.$route.params.shop_id,
                            shopping_guide: this.$route.params.shopping_guide,
                            admin_id: '',
                            name: ''
				        }
                        this.mymTplInit(this.$route.params.deduct_group_price)
                    } else {
                        this.mym_list_form.shop_id = this.shop_list[0].id
                    }
                    this.getMymList(1)
                })
            })
        },
        methods: {
            // 初始化日期插件
            initDate: function() {
                const _this = this
                $(_this.$refs.mym_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.mym_list_form.start_time = start.format('YYYY-MM-DD HH:mm')
                    _this.mym_list_form.end_time = end.format('YYYY-MM-DD HH:mm')
                })
            },
            // 门店
            getShop: function(resolve) {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 管家
            getGuide: function(shop_id, resolve) {
                const _this = this

                _this.mym_list_form.shopping_guide = ''
                _this.mym_list_form.admin_id = ''
                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.guide_list = res.data.response.result
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 获取订单类型
            getOrderType() {
                const _this = this

                Vue.axios.post('PublicData/api_getTicketOrderTypeList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.order_type_list = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },



            // 跳转类型初始化
            mymTplInit(deduct_group_price) {
                if(deduct_group_price == '1') {
                    const arr = []
                    this.mym_tpl_ids = []
                    this.order_type_list.forEach(_ => {
                        if(_.name == '门票' || _.name == '平台票') {
                            this.mym_tpl_ids.push(_.value)
                            arr.push(_.name);
                        }
                    })
                    this.mym_tpl_txt = arr.join(',')
                    this.mym_tpl_sign = true
                } else if(deduct_group_price == '-1') {
                    const arr = []
                    this.mym_tpl_ids = []
                    this.order_type_list.forEach(_ => {
                        if(_.name == '门票') {
                            this.mym_tpl_ids.push(_.value)
                            arr.push(_.name);
                        }
                    })
                    this.mym_tpl_txt = arr.join(',')
                    this.mym_tpl_sign = true
                } else {
                    this.mym_tpl_txt = ''
                    this.mym_tpl_sign = false
                    this.mym_tpl_all = false
                    this.mym_tpl_ids = []
                }
            },
            // 类型
            mymTplSelect() {
                const _this = this;
                const c_mym_tpl_ids = _this.mym_tpl_ids,
                    c_mym_tpl_sign = _this.mym_tpl_sign,
                    c_mym_tpl_all = _this.mym_tpl_all;
                layer.confirm('', {
                    id: 'mymTplAlert',
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.mym_tpl_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.mym_tpl_ids = c_mym_tpl_ids;
                        _this.mym_tpl_sign = c_mym_tpl_sign;
                        _this.mym_tpl_all = c_mym_tpl_all;
                    }
                }, function() {
                    let arr = [];
                    _this.order_type_list.forEach(item => {
                        _this.mym_tpl_ids.forEach(sub => {
                            if(item.value == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.mym_tpl_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.mym_tpl_ids = c_mym_tpl_ids;
                    _this.mym_tpl_sign = c_mym_tpl_sign;
                    _this.mym_tpl_all = c_mym_tpl_all;
                });
            },
            mymTplDel() {
				this.mym_tpl_sign = false;
                this.mym_tpl_all = false;
				this.mym_tpl_ids = [];
            },
            mymTplAll(val) {
                let ids = [];
				this.order_type_list.forEach(v => {
					ids.push(v.value);
				});
				this.mym_tpl_ids = val ? ids : [];
				this.mym_tpl_sign = false;
			},
			mymTplChange(val) {
				const len = val.length;
				this.mym_tpl_sign = len > 0 && len < this.order_type_list.length;
				this.mym_tpl_all = len === this.order_type_list.length;
            },
            // 更换门店
            mymShopChange(shop_id) {
                new Promise(resolve => {
                    this.getGuide(shop_id, resolve)
                })
            },
            getMymList(page) {
				const _this = this;

                _this.loading = true;
                _this.mym_list_page = page;
				Vue.axios.post('TicketOrder/getInfosList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.mym_list_form.start_time,
                            "end_time": _this.mym_list_form.end_time,
							"shop_id": _this.mym_list_form.shop_id,
							"shopping_guide": _this.mym_list_form.shopping_guide,
                            "admin_id": _this.mym_list_form.admin_id,
                            "info_type": _this.mym_tpl_ids,
                            "name": _this.mym_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.mym_list_total = Number(res.data.response.result.total_data.total)
							_this.mym_actual_pay_total = res.data.response.result.total_data.actual_pay_total
						}
						_this.mym_list = res.data.response.result.rows
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 导出
            mymExportAll(val) {
				this.mym_export_ids = val ? this.mym_export_list : [];
				this.mym_export_sign = false;
			},
			mymExportChange(val) {
				const len = val.length;
				this.mym_export_all = len === this.mym_export_list.length;
				this.mym_export_sign = len > 0 && len < this.mym_export_list.length;
			},
            mymExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "TicketOrder/exportInfosList"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.mym_export_ids = res.data.response.result.export_fields;
                            _this.mym_export_type = res.data.response.result.export_type;
                        } else {
                            _this.mym_export_ids = _this.mym_export_list;
                            _this.mym_export_type = '1';
                        }
                        _this.mymExportChange(_this.mym_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.mym_list_export)
                }, function() {
                    _this.mymExport();
                });
            },
            mymExport: function() {
                window.location.href = Vue.ctUrl + "TicketOrder/exportInfosList" +
                    "?start_time=" + this.mym_list_form.start_time +
                    "&end_time=" + this.mym_list_form.end_time +
                    "&shop_id=" + this.mym_list_form.shop_id +
                    "&shopping_guide=" + this.mym_list_form.shopping_guide +
                    "&admin_id=" + this.mym_list_form.admin_id +
                    "&info_type=" + this.mym_tpl_ids +
                    "&name=" + this.mym_list_form.name +
                    "&export_fields=" + JSON.stringify(this.mym_export_ids) +
                    "&export_type=" + this.mym_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
            // 详情
            getMymDet(order_id) {
                const _this = this;

                Vue.axios.post('TicketOrder/getDetail', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "order_id": order_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.mym_order = res.data.response.result
                        _this.mymShowList = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        h2 {
            margin: 20px 0 15px 0;
            font-size: 16px;
        }
    }
</style>